export const LOCALES = {
    PORTUGUESE: 'pt',
    ENGLISH: 'en',
    SPANISH: 'es',
    LIBRAS: 'libra'
}